import { useState } from 'react';

export interface PaginatedFilters {
  page: number;
  limit: number;
  startTime: string;
  endTime: string;
}

export interface UseFiltersResult<T extends PaginatedFilters> {
  filters: T;
  setFilters: React.Dispatch<React.SetStateAction<T>>;
  handleFilterChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  resetFilters: () => void;
  handlePageChange: (newPage: number) => void;
}

export function useFilters<T extends PaginatedFilters>(initialFilters: T): UseFiltersResult<T> {
  const [filters, setFilters] = useState<T>(initialFilters);

  // Функция для обновления фильтров
  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
      // При изменении любого фильтра, кроме page, сбрасываем страницу на первую
      page: name === 'page' ? prev.page : 1,
    }));
  };

  // Функция для сброса фильтров
  const resetFilters = () => {
    setFilters(initialFilters);
  };

  // Функция для изменения страницы
  const handlePageChange = (newPage: number) => {
    setFilters((prev) => ({ ...prev, page: newPage }));
  };

  return {
    filters,
    setFilters,
    handleFilterChange,
    resetFilters,
    handlePageChange,
  };
}
